<template>
    <div class="row">
        <div class="col-lg-12" v-if="printedResults && printedResults.data && printedResults.data.length > 0">
            <input
                v-model="searchText"
                type="search"
                class="input-secondary-light border-radius-none mb-2"
                placeholder="Rechercher un document"
                autocomplete="off"
            />
        </div>

        <div class="col-lg-12 t-all-left">
            <b-table
                hover
                outlined
                :items="printedResults.data"
                :filter="searchText"
                :fields="tableHeadCells"
                :per-page="10"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                responsive="sm"
                @row-clicked="previewDocument"
                tbody-tr-class="cursor-pointer"
                show-empty
            >
            <template #empty>
                <div class="pdtb-6 algn-center">
                    <div class="no-data">
                        <i class="fa fa-exclamation"></i>
                    </div>
                    <h5 class="text-danger font-22">
                        Aucune donnée disponible
                    </h5>
                </div>
            </template>
            <template #emptyfiltered>
                <h5>Aucun résultat trouvé</h5>
            </template>

            <template #cell(status)="data">
                <span :class="{
                    'badge-xs badge-primary-o': data.item.save_mode === 'ready',
                    'badge-xs badge-secondary-o badge-inactive': data.item.save_mode === 'draft'
                }">
                    {{ data.item.save_mode === 'ready' ? 'Actif' : 'Brouillon' }}
                </span>                
            </template>
            <template #cell(actions)="data">
                <b-dropdown variant="link" right no-caret size="xs">
                    <template #button-content>
                        <b-icon icon="three-dots-vertical" variant="dark" class="p-0"></b-icon>
                    </template>
                    <b-dropdown-item href="#" class="pl-0" @click="selectDocument(data.item, 'preview')">
                        <i class="ic-eye"></i> Visualiser
                    </b-dropdown-item>
                    <!-- <b-dropdown-item href="#" class="pl-0" @click="selectDocument(data.item, 'print')">
                        <i class="ic-printing"></i> Imprimer
                    </b-dropdown-item> -->
                    <b-dropdown-item href="#" class="pl-0" @click="selectDocument(data.item, 'delete')">
                        <i class="ic-trash-outline"></i> Supprimer
                    </b-dropdown-item>
                </b-dropdown>
            </template>       
            </b-table>
        </div>

        <ConfirmationModal id="delete-confirm-modal" @confirm="confirmDelete" modalSize="md">
            <template v-slot:subtitle>Etes-vous sûre de vouloir supprimer <br /> le document : </template>
            <strong slot="subtitle2">{{ selectedGroupedAnalysis && selectedGroupedAnalysis.name }}</strong>
        </ConfirmationModal>        
    </div>
</template>

<script>
import ConfirmationModal from '@/components/dialogs/ConfirmationModal.vue';

import $ from 'jquery';
import { showToast } from "@/utils/notifications";

export default {
    name: 'PrintedGroupedAnalysis',
    components: {
        ConfirmationModal,
    },
    props: {
        patientId: {
            type: Number,
            required: true
        },
        printedResults: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            tableHeadCells: [
                { key: "name", label: "Nom du document" },
                // { key: "analysis.count", label: "Nombre d'analyses" },
                { key: "status", label: "Statut" },
                "actions",
            ],
            currentPage: 1,
            sortBy: "name",
            sortDesc: false,
            sortDirection: "asc",
            searchText: "",

            selectedGroupedAnalysis: undefined,
        }
    },
    mounted() {},
    methods: {
        selectDocument(item, action) {
            this.selectedGroupedAnalysis = item;

            if(action === 'delete') {
                this.$bvModal.show('delete-confirm-modal');
            }

            if(action === 'preview') {
                this.previewDocument(item);
            }
        },
        async confirmDelete() {
            const data = {
                patientId: this.patientId,
                groupedAnalyseId: this.selectedGroupedAnalysis && this.selectedGroupedAnalysis.id
            }

            const response = await this.$store.dispatch('deleteGroupedAnalyse', data);

            if(response.status === 200 || response.status === 204) {
                this.$bvModal.hide('delete-confirm-modal');
                showToast("Le document a été supprimé avec succès", "success");
                this.$store.dispatch('getGroupedAnalysesByPatientId', this.patientId);
            }
        },
        previewDocument(item) {
            this.$store.dispatch('setGroupedResults', item);
            $('#preview-grouped-analyses-modal').modal('show');
        },
    }
}
</script>

<style>

</style>
